import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getScheduleHostList = async ({ queries }) => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `/schedule/user/host/list?${queries}`,
  });

  return data?.data;
};

export default getScheduleHostList;
